import { _, debug } from '../utils.js'
import axios from 'axios'
import Loading from '../modules/loading.js'
import errorMessageContainer from '../templates/error.js'

export default class QuizResults {
    constructor(el) {
        this.el = el
        this.resultsContainer = _('results-container', 'element').nodeFrom(
            this.el,
        )
        this.defaultErrorMessage =
            'Something has gone quite wrong, please try to refresh your browser or contact us.'

        this.getStatus()
    }

    showLoading = () => {
        this.resultsContainer.innerHTML =
            '<div class="loading" data-behaviour="loading"></div>'
        _('loading')
            .nodes()
            .map((el) => new Loading(el))
    }

    hideLoading = () => {
        this.resultsContainer.innerHTML = ''
    }

    getStatus = () => {
        this.showLoading()
        axios({
            method: 'get',
            url: '/api/compliance-test/status',
        })
            .then((response) => {
                if (response.status !== 200) {
                    return this.handleError(response)
                }
                this.handleSuccess(response)
            })
            .catch((error) => {
                this.handleError(error)
            })
    }

    handleSuccess = (response) => {
        let innerHTML = ''

        if (response.data.result.testDetails.passed === true) {
            innerHTML += `<h2 class="heading--3">You have passed the compliance test.</h2>
                <p>Your score is: ${response.data.result.testDetails.score}%</p>
                `
        } else if (response.data.result.testDetails.passed === false) {
            innerHTML +=
                '<h2 class="heading--3">You have failed the compliance test.</h2>'
            if (response.data.result.remainingAttempts < 1) {
                innerHTML +=
                    '<p>You have no more attempts left, please contact the REC.</p>'
            } else {
                innerHTML += `<p>You have ${
                    response.data.result.remainingAttempts
                } attempt${
                    response.data.result.remainingAttempts > 1 ? 's' : ''
                } left:</p>
                <p><a class="button" href="/compliance/compliance-test">Start Compliance Test</a></p>`
            }
        } else {
            innerHTML += `<h2 class="heading--3">You haven't yet taken the test yet.</h2>
                <p><a class="button" href="/compliance/compliance-test">Start Compliance Test</a></p>
                `
        }

        this.resultsContainer.innerHTML = innerHTML
    }

    handleError = (err, defaultMessage = this.defaultErrorMessage) => {
        if (debug) {
            console.warn({ err })
        }
        let errorHTML = `<p>${defaultMessage}</p>`
        if (err && err.response && err.response.data.error) {
            errorHTML = `<p>${err.response.data.error}</p>`
        }
        errorHTML = errorMessageContainer(errorHTML)
        if (err && err.response && err.response.status === 401) {
            if (debug) {
                console.warn('401: not logged in')
            }
            errorHTML +=
                '<p><a href="/my-account" class="button button--h-small button--v-small button--white">Login</a></p>'
        }
        if (err && err.response && err.response.status === 400) {
            if (debug) {
                console.warn('400: no active test')
            }
            errorHTML = `<h2 class="heading--3">You haven't got an active test.</h2>
                <p><a class="button" href="/compliance/compliance-test">Start Compliance Test</a></p>`
        }
        this.resultsContainer.innerHTML = errorHTML
    }
}
